module.exports = __webpack_public_path__ + "img/lingyin.f3a57c6.svg";